import { loadableReady } from '@loadable/component';
import PoweredBy from '@readme/server-shared/powered-by-log'; // eslint-disable-line readme-internal/no-restricted-imports
import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import DebugRouter from '@core/utils/DebugRouter';

import { init as initializeI18n } from './i18n';
import crossFrameHistory from './utils/crossFrameHistory';

import App from '.';

PoweredBy();

// eslint-disable-next-line no-multi-assign
let FIRST_RUN = (window.FIRST_RUN = !('rehydrate' in window));

if (FIRST_RUN) {
  window.rehydrate = (props = {}) => {
    const root = document.getElementById('ssr-main');
    if (root) {
      const historyOptions = {
        basename: props.baseUrl,
        forceRefresh: !!props.is404,
      };

      hydrateRoot(
        root,
        <DebugRouter history={crossFrameHistory(historyOptions)}>
          <App {...props} />
        </DebugRouter>,
      );
    }
  };
}
const rehydrate = window.rehydrate;

function initialize() {
  if (FIRST_RUN) {
    // run an immediate render pass
    let initialProps;
    try {
      const elem = document.querySelector('#ssr-props[data-initial-props]');
      const data = elem.dataset.initialProps;
      initialProps = JSON.parse(data);
      elem.remove();
    } catch (e) {
      initialProps = {};
    }

    // Initialize i18n with the current language and translation data
    initializeI18n(initialProps.i18n.language || 'en', initialProps.i18n.translations || {});

    loadableReady(() => rehydrate(initialProps));

    // set up globals
    window.rehydrate = () => rehydrate(initialProps);

    // toggle the init flag
    FIRST_RUN = false;
  }
}

const holdInitialization = setInterval(() => {
  if (typeof $ !== 'undefined') {
    clearInterval(holdInitialization);
    initialize();
  }
}, 300);
